import axiosClient from "./axiosClient";
import type { PushOptionsInput } from "./push-broadcast-api";

const BASE = "/admin/push/templates";

export interface PushTemplatePayload extends PushOptionsInput {
    name: string;
    title: string;
    message: string;
    openPath?: string;
    openUrl?: string;
}

const pushTemplateApi = {
    listTemplates() {
        return axiosClient.get(BASE);
    },
    createTemplate(payload: PushTemplatePayload) {
        return axiosClient.post(BASE, payload);
    },
    updateTemplate(id: number, payload: PushTemplatePayload) {
        return axiosClient.put(`${BASE}/${id}`, payload);
    },
    deleteTemplate(id: number) {
        return axiosClient.delete(`${BASE}/${id}`);
    },
};

export default pushTemplateApi;
